module.exports = __webpack_public_path__ + "img/weisswein.fd3e963e.jpg";